import React, { useState } from "react";

import styles from "../Financial.module.css";

import { Container, Main } from "../../../components/Container";
import { Table, Dropdown, Modal, Form, Col, Row } from "react-bootstrap";

import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import IcExport3 from "../../../components/Svg/IcExport3";
import IcExport from "../../../components/Svg/IcExport2";
import IcMail2 from "../../../components/Svg/IcMail2";
import IcDown from "../../../components/Svg/IcSetaDown";
import IcSearch from "../../../components/Svg/IcSearch";
import IcMais from "../../../components/Svg/IcMais";
import IcEmptyTable from "../../../components/Svg/IcEmptyTable";
import { Bills } from "../style";

import styleTab from "../../../components/Tab/Tab.module.css";
import Slct from "../../../components/Slct";

export default function Trainees() {
  const [showMenu, setShowMenu] = useState("hide");

  function toggleMenu() {
    if (showMenu === "hide") {
      setShowMenu("show");
    } else {
      setShowMenu("hide");
    }
  }

  const [show2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  // const menuVis = this.state.showMenu ? 'show' : 'hide';

  return (
    <Bills>
      <Main className="multiplusContainers">
        <Container className="containerBLock mb-0">
          <div className="topoBills">
            <div className="">
              <h2 className="titlePage mb-1">Gerenciar Boletos</h2>
              <p>No menu abaixo, selecione ano e mês para consultar os boletos por situação.</p>
              <p>Para criar um novo boleto manualmente, clique em Novo Boleto.</p>
            </div>
            <div className="btnsTopoBills">
              <NavLink className="btnGhost smallIcon" to="/trainees/new">
                <IcExport />
                Exportar Relatório
              </NavLink>
              <button type="button" onClick={handleShow4} className="buttonNew">
                Novo Boleto
              </button>
              {/* <Background /> */}
            </div>
          </div>
        </Container>
        <Container className={`${styles._clean} containerBLock`}>
          <Row>
            <Col sm={3}>
              <Form.Group className="selectContainer">
                <span className="lince-input_label">Assistente</span>
                <Slct
                  options={[
                    { value: "1", label: "Todos Recebimentos" },
                    { value: "2", label: "Vencimento no Mês Corrente" },
                    { value: "3", label: "Vencimento Hoje" },
                    { value: "4", label: "A receber" },
                    { value: "5", label: "Recebidos" },
                    { value: "6", label: "Vencidos" },
                    { value: "7", label: "Emitidos" },
                    { value: "8", label: "Cancelados" },
                  ]}
                />
              </Form.Group>
            </Col>
            <Col sm={2}>
              <Form.Group className="selectContainer">
                <span className="lince-input_label">Status da Turma</span>
                <Slct
                  options={[
                    { value: "1", label: "Contrato" },
                    { value: "2", label: "Finalizadas" },
                    { value: "3", label: "Canceladas" },
                  ]}
                  placeholder="..."
                />
              </Form.Group>
            </Col>
            <Col sm={2}>
              <Form.Group className="selectContainer">
                <span className="lince-input_label">Contrato</span>
                <Slct
                  options={[
                    { value: "1", label: "Contrato 1" },
                    { value: "2", label: "Contrato 2" },
                    { value: "3", label: "Contrato 3" },
                  ]}
                  placeholder="..."
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-6">
            <Col sm={2}>
              <Form.Group className="selectContainer">
                <span className="lince-input_label">Momento</span>
                <Slct
                  options={[
                    { value: "2021", label: "Vencimento" },
                    { value: "2022", label: "Emissão" },
                  ]}
                />
              </Form.Group>
            </Col>
            <Col sm={2}>
              <Form.Group className="selectContainer">
                <span className="lince-input_label">Ano</span>
                <Slct
                  options={[
                    { value: "2021", label: "2021" },
                    { value: "2022", label: "2022" },
                    { value: "2023", label: "2023" },
                  ]}
                />
              </Form.Group>
            </Col>
            <Col sm={8}>
              <Form.Group>
                <span className="lince-input_label">Mês</span>
                <div className={styleTab.tab}>
                  <button className="active">Todos</button>
                  <button>Jan</button>
                  <button>Fev</button>
                  <button>Mar</button>
                  <button>Abr</button>
                  <button>Mai</button>
                  <button>Jun</button>
                  <button>Jul</button>
                  <button>Ago</button>
                  <button>Set</button>
                  <button>Out</button>
                  <button>Nov</button>
                  <button>Dez</button>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Container>
        <Container className="containerBLock mt-0">
          <div className="buscaBills">
            <div className="-busca">
              <h3>Janeiro 2021</h3>
              <Form.Group className="lince-input" controlId="validationCustom01">
                <div className="lince-input__text">
                  <Form.Control required type="text" name="title" placeholder="Nome do formando" />
                </div>
                <IcSearch />
              </Form.Group>
            </div>
            <div className="--previsao">
              <h4>Previsão de receita:</h4>
              <p>
                <span>Janeiro 2021</span>
                <span>R$540,00</span>
              </p>
            </div>
          </div>

          <ul className="listboletos mt-4">
            <li>
              <button className="active">
                A Vender <span>50</span>
              </button>
            </li>
            <li>
              <button>
                Atrasados <span>50</span>
              </button>
            </li>
            <li>
              <button>
                Pagos <span>0</span>
              </button>
            </li>
            <li>
              <button>
                Cancelados <span>50</span>
              </button>
            </li>
            <li>
              <button>
                Não Gerados <span>50</span>
              </button>
            </li>
          </ul>

          <Table responsive className="tableConteudo mt-2">
            <thead>
              <tr>
                <th className="flex noPdLt">
                  <Dropdown>
                    <Dropdown.Toggle className="filterDropdownButton">
                      FORMANDO: <span></span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="filterDropdownItem">
                      <Dropdown.Item className="full">A-Z</Dropdown.Item>
                      <Dropdown.Item className="full">Z-A</Dropdown.Item>
                      <Dropdown.Item zzzclassName="full">Data de adição</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </th>
                <th className="labelTable" style={{ width: "150px" }}>
                  Valor
                </th>
                <th className="labelTable" style={{ width: "150px" }}>
                  Vencimento
                </th>
                <th className="labelTable" style={{ width: "100px" }}>
                  Parcela
                </th>
                <th className="labelTable" style={{ width: "150px" }}>
                  Descrição
                </th>
                <th className="labelTable" style={{ width: "100px" }}>
                  Código
                </th>
                <th className="labelTable"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h5 className="formando">João Silva</h5>
                </td>
                <td className="small">R$ 135,00</td>
                <td className="small">10/02/1058</td>
                <td>01/24</td>
                <td>
                  <button onClick={toggleMenu} className={`btnVertabela ${showMenu}`}>
                    Ver <IcDown />
                  </button>
                </td>
                <td>123</td>
                <td className="tdAcoes">
                  <div className="btnsAcoes">
                    <button className="btnGhost -table">
                      {" "}
                      <IcMail2 />
                      Reenviar Boleto
                    </button>
                    <button className="btnGhost -table">
                      <IcExport3 /> Download
                    </button>
                    <Dropdown>
                      <Dropdown.Toggle className="btnDrop btnGhost -table">
                        <FontAwesomeIcon icon={faEllipsisH} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="">
                        <Dropdown.Item as="button" onClick={handleShow2}>
                          Receber pagamento manual
                        </Dropdown.Item>
                        <Dropdown.Item as="button" onClick={handleShow3}>
                          Cancelar boleto
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr className={`descricaoTable ${showMenu}`}>
                <td colSpan="7" className="vermaisDescricao">
                  <p>
                    <b>Descrição:</b> Parcela referente à substituição do valor do cartão.
                  </p>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="tableEmpty text-center">
            <IcEmptyTable />
          </div>

          <Modal show={show4} onHide={handleClose4} size="lg" aria-labelledby="contained-modal-title-vcenter " centered>
            <Modal.Header className="border">
              <Modal.Title>Novo boleto</Modal.Title>
              <button className="closeModal" onClick={handleClose4}>
                <IcMais />
              </button>
            </Modal.Header>
            <Modal.Body className="bgWhite">
              <Form.Check.Label className="lince-input fullW">
                <Form.Group className="lince-input" controlId="validationCustom01">
                  <span className="lince-input_label">Nome do formando:</span>
                  <div className="lince-input__text">
                    <Form.Control required type="text" name="name" />
                  </div>
                </Form.Group>
              </Form.Check.Label>
              <div className="infoFormando">
                <ul>
                  <li>
                    <p>
                      Nome Completo<span>Thiago Farias Evangelista</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      CPF<span>123.123.123-90</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      Turma<span>MEDUFS2025.1</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      E-mail<span>thiago@email.com</span>
                    </p>
                  </li>
                </ul>
              </div>
              <Table responsive className="tableConteudo tableHeadColor mt-2">
                <thead>
                  <tr>
                    <th className="labelTable">Valor</th>
                    <th className="labelTable" style={{ width: "200px" }}>
                      Data de vencimento
                    </th>
                    <th className="labelTable">Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Form.Check.Label className="lince-input">
                        <Form.Group className="lince-input" controlId="validationCustom01">
                          <div className="lince-input__text">
                            <Form.Control required type="text" name="name" />
                          </div>
                        </Form.Group>
                      </Form.Check.Label>
                    </td>
                    <td>
                      <Form.Check.Label className="lince-input">
                        <Form.Group className="lince-input">
                          <div className="lince-input__text">
                            <Form.Control required type="date" name="date_birth" />
                          </div>
                        </Form.Group>
                      </Form.Check.Label>
                    </td>
                    <td>
                      <Form.Check.Label className="lince-input fullW">
                        <Form.Group className="lince-input " controlId="validationCustom01">
                          <div className="lince-input__text">
                            <Form.Control required type="text" name="name" />
                          </div>
                        </Form.Group>
                      </Form.Check.Label>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <div className="btsApagarMsg d-flex justify-content-end mt-2">
                <button onClick={handleClose4} className="salvar mb-0 mr-0">
                  Criar Boleto
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal show={show3} onHide={handleClose3} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className="border">
              <Modal.Title>Cancelar boleto?</Modal.Title>
              <button className="closeModal" onClick={handleClose3}>
                <IcMais />
              </button>
            </Modal.Header>
            <Modal.Body className="bgWhite">
              <p>
                Ao cancelar este boleto, o valor referente irá ser adicionado como débito na conta do formando e da sua
                respectiva turma. Deseja continuar?
              </p>
              <div className="btsApagarMsg d-flex justify-content-end mt-3">
                <button onClick={handleClose3} className="btnGhost cancelar mr-1 mb-0">
                  Cancelar
                </button>
                <button onClick={handleClose3} className="salvar mb-0 mr-0">
                  Continuar
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal show={show2} onHide={handleClose2} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className="border">
              <Modal.Title>Receber pagamento manual?</Modal.Title>
              <button className="closeModal" onClick={handleClose2}>
                <IcMais />
              </button>
            </Modal.Header>
            <Modal.Body className="bgWhite">
              <p>
                Ao marcar este pagamento como manual, você irá cancelar este boleto e declarar que o valor foi recebido
                de outra forma. Selecione abaixo o método que foi utilizado para receber o valor quitado:
              </p>
              <Form.Check.Label className="lince-input ltSelect fullW">
                <div className="lince-input__select">
                  <Form.Control required as="select" name="ssp_state_id">
                    <option value="">Selecione o método de pagamento</option>
                    <option value="teste">Dinheiro em espécie</option>
                  </Form.Control>
                </div>
              </Form.Check.Label>
              <div className="btsApagarMsg d-flex justify-content-end mt-3">
                <button onClick={handleClose2} className="btnGhost cancelar mr-1 mb-0">
                  Voltar
                </button>
                <button onClick={handleClose2} className="salvar mb-0 mr-0">
                  Continuar
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </Container>
      </Main>
    </Bills>
  );
}
